const ForSaleTag = () => {
  return (
    <div className="w-max flex items-center gap-[5px] px-[6px] py-[.125rem] rounded-[1.5625rem] text-body-xs font-red-hat h-[1.375rem] text-white bg-[#97cc04]">
      <div className="w-[.375rem] h-[.375rem] rounded-full bg-white"></div>
      En venta
    </div>
  )
}

const ForRentTag = () => {
  return (
    <div className="w-max flex items-center gap-[5px] px-[6px] py-[.125rem] rounded-[1.5625rem] text-body-xs font-red-hat h-[1.375rem] text-white bg-[#00c0c4]">
      <div className="w-[.375rem] h-[.375rem] rounded-full bg-white"></div>
      En renta
    </div>
  )
}

export { ForSaleTag, ForRentTag }
